import services from './services.js';
import NProgress from 'nprogress';
import Uploader from 'uploader';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import viewPhoto from 'src/common/js/viewPhoto';
import $http from '$http';
import {
    MAP_LIST
} from '$http';

export default {
    mixins: [services],
    data() {
        return {
            ProjectList: MAP_LIST.INTENT_PROJECT,
            AddressTypes: [{
                'id': 0,
                'name': "园所地址"
            }, {
                'id': 1,
                'name': "代理商地址 "
            }, {
                'id': 2,
                'name': "设备园所-资源包代理商"
            }],
            dialogVisible: false,
            loading: false,
            submitFormData: this.getAddFormData(), //提交的数据
            title: '添加套餐规则',
            IsDeductibleTypes: [{
                'id': 1,
                'value': '是'
            }, {
                'id': 0,
                'value': '否'
            }],
            accountTypes: [],
            isAddBtnShow: [true],
            isDelBtnShow: [false],
            isDkShow: false, //抵扣顺序
            isShelfTimeShow: false,
            isDownTime: false, //下架时间显示true
            isChange: false,
            PackageTypes: [{
                ParmName: 2,
                ParmRemark: "ces"
            }],
        }
    },
    computed: {},
    methods: {
        getAddFormData() {
            return cloneDeep({
                "PackageId": '',
                "PackageName": "",
                "ProjectType": '',
                "Status": 0,
                "StandardAmount": "",
                "SupportGoods": "",
                "ReceivingType": '',
                "Rules": "",
                "ShelfTime": "",
                "OverTime": "",
                "Remark": "",
                "IsDeductible": '',
                "DeductibleOrder": [{
                    "Id": ''
                }]
            });
        },
        dialogClose() {
            this.dialogVisible = false;
            this.submitFormData = this.getAddFormData();
            this.isAddBtnShow = [true];
            this.isDelBtnShow = [false];
        },
        changePackage(val) {
            console.log(val)
            //this.submitFormData.PackageId = val
        },
        show(options) {
            let opts = $.extend({}, options);
            this.dialogVisible = true;

            if (opts.isChange) {
                this.title = '修改套餐规则'
                this.isChange = opts.isChange
                this.getPackageRuleData(opts.id)
            } else {
                this.title = '添加套餐规则'
                this.isChange = false
                this.submitFormData = this.getAddFormData()
            }
            this.getInitData()
        },
        removeList(index) {
            if (index !== -1) {
                this.submitFormData.DeductibleOrder.splice(index, 1)
                this.isAddBtnShow.shift(false)
                this.isDelBtnShow.pop(true)
            }
        },
        addList() {
            this.submitFormData.DeductibleOrder.push({
                Id: ''
            });
            this.isDelBtnShow.push(true); //删除按钮
            this.isAddBtnShow.unshift(false); //新增按钮
        },
        selsect(val) {
            if (val == 1) {
                //抵扣
                this.isDkShow = true
            } else {
                this.isDkShow = false
                this.submitFormData.DeductibleOrder = [{
                    "Id": ''
                }]
            }
        },
        // 状态选择
        statusChange(val) {
            if (val == 0) {
                // 未上架
                this.isShelfTimeShow = false
                this.isDownTime = false
            } else if (val == 1) {
                // 上架
                this.isShelfTimeShow = true
                this.isDownTime = false
            } else {
                // 下架
                this.isShelfTimeShow = true
                this.isDownTime = true
            }
        },
        // 提交数据
        submit() {
            for (let i = 0; i < this.PackageTypes.length; i++) {
                if (this.submitFormData.PackageId == this.PackageTypes[i].ParmName) {
                    this.submitFormData.PackageName = this.PackageTypes[i].ParmRemark
                }
            }
            let flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "套餐名",
                    value: this.submitFormData.PackageName,
                    required: true

                }, {
                    name: "套餐ID",
                    value: this.submitFormData.PackageId,
                    required: true,
                    isNumber: true

                }, {
                    name: "套餐标准金额",
                    value: this.submitFormData.StandardAmount,
                    required: true
                }, {
                    name: "配套商品",
                    value: this.submitFormData.SupportGoods,
                    required: true
                }, {
                    name: "规则",
                    value: this.submitFormData.Rules,
                    required: true
                }]
            });
            if (!flag) {
                return;
            }

            if (this.submitFormData.ProjectType == '') {
                this.$notify({
                    title: '警告',
                    message: '请选择项目！',
                    type: 'warning'
                });
                return;
            }
            if (this.submitFormData.ReceivingType === '') {
                this.$notify({
                    title: '警告',
                    message: '请选择收货地址！',
                    type: 'warning'
                });
                return;
            }
            if (this.submitFormData.IsDeductible === '') {
                this.$notify({
                    title: '警告',
                    message: '请选择是否抵扣！',
                    type: 'warning'
                });
                return;
            }
            if (this.isShelfTimeShow) {
                if (this.submitFormData.ShelfTime == '') {
                    this.$notify({
                        title: '警告',
                        message: '请选择上架时间！',
                        type: 'warning'
                    });
                    return;
                }
            }
            if (this.isDownTime) {
                if (this.submitFormData.OverTime == '') {
                    this.$notify({
                        title: '警告',
                        message: '请选择下架时间！',
                        type: 'warning'
                    });
                    return;
                }
            }
            let arr = []

            if (this.submitFormData.IsDeductible == 1) {
                if (this.submitFormData.DeductibleOrder.length > 0) {
                    // 过滤数据
                    for (let i = 0; i < this.submitFormData.DeductibleOrder.length; i++) {

                        if (this.submitFormData.DeductibleOrder[i].Id == '') {

                            this.isAddBtnShow.shift(false)
                            this.isDelBtnShow.pop(true)
                        } else {
                            arr.push({
                                Id: this.submitFormData.DeductibleOrder[i].Id
                            })
                        }
                    }
                    this.submitFormData.DeductibleOrder = arr

                } else {
                    this.$notify({
                        title: '警告',
                        message: '请选择抵扣顺序！',
                        type: 'warning'
                    });
                    return;
                }
            }
            this.submitPackageRule(this.submitFormData)
        }
    },
    created() {

        this.getPackageData()

    }
};


// WEBPACK FOOTER //
// ./src/pages/Memorandum/PackageRule/components/addPackageRule/vm.js